import React, { useState, useEffect, useRef } from "react";
import LoaderPage from "../pages/LoaderPage";
import { getToday } from "../api";
import {
  todayMMDDYY,
  tomorrowMMDDYY,
  nowPretty,
  format12h,
  todayPretty,
  tomorrowPretty,
  scheduleMidnightReload,
  compareTime,
} from "../utils/date";

import paypal from "./main/pic/paypal.png";
import zelle from "./main/pic/zelle.png";
import MICLogo from "./main/pic/MICLogo.png";
// import background from "./pic/pattern.png";
// import IQAMAH from "../main/pic/IQAMAH.mp3";

//email:micnytv@gmail.com
// Password: Micnytv@gmail.com@123

// samsung tv login: micnytv@gmail.com
// samsung tv password: MED$%#GehGHdf34
const azanAudio = new Audio("/azan.mp3"); // Put azan.mp3 in public folder

function gmod(n, m) {
  return ((n % m) + m) % m;
}

/* @param {Date}   date   - optional, default is today
 ** @param {number} adjust - optiona, days to adjust date by
 */
function kuwaiticalendar(date, adjust) {
  var today = date ? new Date(+date) : new Date();
  if (adjust) {
    today.setDate(today.getDate() + +adjust);
  }

  var day = today.getDate();
  var month = today.getMonth();
  var year = today.getFullYear();
  var m = month + 1;
  var y = year;

  if (m < 3) {
    y -= 1;
    m += 12;
  }

  var a = Math.floor(y / 100);
  var b = 2 - a + Math.floor(a / 4);

  if (y < 1583) b = 0;
  if (y == 1582) {
    if (m > 10) b = -10;
    if (m == 10) {
      b = 0;
      if (day > 4) b = -10;
    }
  }

  var jd =
    Math.floor(365.25 * (y + 4716)) +
    Math.floor(30.6001 * (m + 1)) +
    day +
    b -
    1524;

  b = 0;
  if (jd > 2299160) {
    a = Math.floor((jd - 1867216.25) / 36524.25);
    b = 1 + a - Math.floor(a / 4);
  }

  var bb = jd + b + 1524;
  var cc = Math.floor((bb - 122.1) / 365.25);
  var dd = Math.floor(365.25 * cc);
  var ee = Math.floor((bb - dd) / 30.6001);
  day = bb - dd - Math.floor(30.6001 * ee);
  month = ee - 1;

  if (ee > 13) {
    cc += 1;
    month = ee - 13;
  }
  year = cc - 4716;
  var wd = gmod(jd + 1, 7) + 1;

  var iyear = 10631 / 30;
  var epochastro = 1948084;
  var epochcivil = 1948085;

  var shift1 = 8.01 / 60;

  var z = jd - epochastro;
  var cyc = Math.floor(z / 10631);
  z = z - 10631 * cyc;
  var j = Math.floor((z - shift1) / iyear);
  var iy = 30 * cyc + j;
  z = z - Math.floor(j * iyear + shift1);
  var im = Math.floor((z + 28.5001) / 29.5);

  if (im == 13) im = 12;
  var id = z - Math.floor(29.5001 * im - 29);

  return [
    day, //calculated day (CE)
    month - 1, //calculated month (CE)
    year, //calculated year (CE)
    jd - 1, //julian day number
    wd - 1, //weekday number
    id, //islamic date
    im - 1, //islamic month
    iy, //islamic year
  ];
}

function writeIslamicDate(date, adjustment) {
  var wdNames = [
    "Ahad",
    "Ithnin",
    "Thulatha",
    "Arbaa",
    "Khams",
    "Jumuah",
    "Sabt",
  ];
  var iMonthNames = [
    "Muharram",
    "Safar",
    "Rabi'ul Awwal",
    "Rabi'ul Akhir",
    "Jumadal Ula",
    "Jumadal Akhira",
    "Rajab",
    "Sha'ban",
    "Ramadan",
    "Shawwal",
    "Dhul Qa'ada",
    "Dhul Hijja",
  ];
  var iDate = kuwaiticalendar(date, adjustment);
  var outputIslamicDate =
    wdNames[iDate[4]] +
    ", " +
    iDate[5] +
    " " +
    iMonthNames[iDate[6]] +
    " " +
    iDate[7] +
    " AH";
  return outputIslamicDate;
}

const formatTime = (date) => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;
  const secondsStr = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutesStr + ":" + secondsStr + " " + ampm;
};

const FrontDeskNewDataData = () => {
  const [data, setData] = useState(null);
  const [processed, setProcessed] = useState(null);
  const [tData, setTData] = useState(null);
  const [now, setNow] = useState(nowPretty());
  const [today, setToday] = useState(todayPretty());
  const [tomorroww, setTomorroww] = useState(tomorrowPretty());
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  //step1: below is for pulling today's data from backend api
  useEffect(() => {
    getToday(todayMMDDYY())
      .then(setData)
      .then(() => setIsLoading(false))
      .catch((e) => {
        setError(e.message);
        setIsLoading(false);
      });
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  //above is for pulling  today's data from backend api

  // Step 2: Run your function only after data is ready
  useEffect(() => {
    if (data) {
      const output = runAfterData(data); // your custom function
      setProcessed(output); // store processed result
    }
  }, [data]); // ekhan e data change holei run hobe abong data ready thakle run hobe abong data er upor depend kore abong data pura load hole tar por next line ta run hobe

  // Example function that depends on data
  function runAfterData(data) {
    // do something with data
    // console.log(data);
  }

  // below is for pulling tomorrow's data from backend api
  useEffect(() => {
    getToday(tomorrowMMDDYY())
      .then(setTData)
      .catch(() => {});
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  // above is for pulling tomorrow's data from backend api

  // below line for countdown for 5 prayers or u can say how much time remaining for next prayer🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below line for countdown for 5 prayers or u can say how much time remaining for next prayer🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽

  const [nextPrayer1, setNextPrayer1] = useState(null);
  const [countdown1, setCountdown1] = useState("");

  function timeToSeconds(str) {
    const chars = Array.from(str);
    const colonIndex = chars.indexOf(":");
    const h = Number(chars.slice(0, colonIndex).join(""));
    const m = Number(chars.slice(colonIndex + 1).join(""));
    return h * 3600 + m * 60;
  }

  const order = [
    "fajrIqamah",
    "dhuhrIqamah",
    "asrIqamah",
    "maghribIqamah",
    "ishaIqamah",
  ];

  // Step 1: find the next prayer time
  function getNextPrayer() {
    const now = new Date();
    const nowSec =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    for (let i = 0; i < order.length; i++) {
      const key = order[i];
      const targetSec = data && timeToSeconds(data[key]);
      if (targetSec > nowSec) {
        return key;
      }
    }
    // if past isha, loop back to fajr
    return "fajrIqamah";
  }

  // Step 2: update countdown every second
  useEffect(() => {
    function tick() {
      const key = data && getNextPrayer();
      setNextPrayer1(key);

      const now = new Date();
      const nowSec =
        now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      const targetSec = data && timeToSeconds(data[key]);

      // if target is tomorrow (after isha), add 24h
      const diffSec =
        targetSec > nowSec
          ? targetSec - nowSec
          : 24 * 3600 - nowSec + targetSec;

      const h = Math.floor(diffSec / 3600);
      const m = Math.floor((diffSec % 3600) / 60);
      const s = diffSec % 60;

      // format with leading zeros
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      const ss = String(s).padStart(2, "0");

      setCountdown1(`${hh}:${mm}:${ss}`);
    }

    tick(); // run immediately
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [data]);

  function removeIqamah(key) {
    return key?.endsWith("Iqamah")
      ? key?.slice(0, -"Iqamah".length) // remove last 6 chars
      : key;
  }

  // above line for countdown for 5 prayers or u can say how much time remaining for next prayer 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above line for countdown for 5 prayers or u can say how much time remaining for next prayer 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  const [isVisible, setIsVisible] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [hijriDate, setHijriDate] = useState("");
  const audioRef = useRef(null);

  const [isPlayingAzan, setIsPlayingAzan] = useState(false);

  //below is for per second for NOW Clock🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  //below is Now er next line ta holo per second update er jonno
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  //above is Now er next line ta holo per second update er jonno
  //above is Now er next line ta holo per second update er jonno

  //below is for arabic date🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  useEffect(() => {
    const today = new Date();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      calendar: "islamic",
      numberingSystem: "latn",
    };
    const hijriFormatter = new Intl.DateTimeFormat("en-US", options);
    const formattedHijri = hijriFormatter.format(today);
    setHijriDate(formattedHijri);
  }, []);
  //above is for arabic date

  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  const [currentPrayer, setCurrentPrayer] = useState("");
  useEffect(() => {
    const checkPrayer = () => {
      const today = new Date();
      const todayDate = today.toLocaleDateString("en-US"); // "12/14/2025"
      // Your dataset uses "12/14/25" instead of "2025"
      const todayShort = todayDate.replace(/(\d+)$/, (y) => y.slice(-2)); // "12/14/25"
      // console.log(todayShort);
      // Find today's row
      // Normalize both to the same format
      function normalizeDate(str) {
        const [month, day, year] = str.split("/");
        return `${Number(month)}/${Number(day)}/${year}`;
      }

      const todayData =
        data && normalizeDate(data.date) === normalizeDate(todayShort);
      // console.log(data && data);
      // console.log(todayData);
      // console.log(data);

      // console.log(todayData.Fajr);
      // console.log(data && data?.fajr);

      // console.log(timeToSeconds(todayData.Fajr));
      // console.log(
      //   data?.fajr && data.fajr !== "null" && data?.fajr.trim() !== ""
      //     ? data?.fajr
      //         .split(":")
      //         .map(Number)
      //         .reduce((acc, v, i) => acc + v * (i ? 60 : 3600), 0)
      //     : null
      // );
      // console.log(
      //   data?.fajr?.includes(":")
      //     ? data?.fajr
      //         .split(":")
      //         .map(Number)
      //         .reduce((acc, v, i) => acc + v * (i ? 60 : 3600), 0)
      //     : null
      // );
      // console.log(todayData);

      function timeToSeconds(timeStr) {
        const [h, m] = timeStr && timeStr.split(":").map(Number);
        return h * 3600 + m * 60;
      }

      const fajr = data && timeToSeconds(data?.fajr);
      // console.log(fajr);

      const dhuhr = data && timeToSeconds(data?.dhuhr);
      // console.log(dhuhr);

      const asr = data && timeToSeconds(data?.asr);
      // console.log(asr);

      const maghrib = data && timeToSeconds(data?.maghrib);
      // console.log(maghrib);

      const isha = data && timeToSeconds(data?.isha);
      // console.log(isha);

      const nowSec =
        today.getHours() * 3600 + today.getMinutes() * 60 + today.getSeconds();

      // console.log(nowSec);

      if (nowSec >= fajr && nowSec < dhuhr) {
        setCurrentPrayer("Fajr");
      } else if (nowSec >= dhuhr && nowSec < asr) {
        setCurrentPrayer("Dhuhr");
      } else if (nowSec >= asr && nowSec < maghrib) {
        setCurrentPrayer("Asr");
      } else if (nowSec >= maghrib && nowSec < isha) {
        setCurrentPrayer("Maghrib");
      } else {
        // Isha until next day's Fajr
        setCurrentPrayer("Isha");
      }
    };

    checkPrayer();
    const interval = setInterval(checkPrayer, 1000);
    return () => clearInterval(interval);
  }, [data]);

  // console.log(currentPrayer);

  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //below useeffect will refresh page everyday at 12:05AM

  useEffect(() => {
    // Function to get the next 12:05 AM
    const getNextRefreshTime = () => {
      const now = new Date();
      const next = new Date();
      next.setHours(0, 5, 0, 0); // 12:05 AM today
      // next.setHours(19, 35, 0, 0);
      if (now > next) {
        next.setDate(next.getDate() + 1); // if past 12:05, schedule for tomorrow
      }
      return next;
    };

    const nextRefresh = getNextRefreshTime();
    const timeUntilRefresh = nextRefresh.getTime() - Date.now();

    const timer = setTimeout(() => {
      window.location.reload();
    }, timeUntilRefresh);

    return () => clearTimeout(timer);
  }, []);

  //above useeffect will refresh page everyday at 12:05AM

  // const [now, setNow] = useState(new Date());
  // const [activeWindow, setActiveWindow] = useState(null); // { prayerName, day, start, end }
  // const beepPlayed = useRef(false);

  // tick every second
  // useEffect(() => {
  //   const id = setInterval(() => setNow(new Date()), 1000);
  //   return () => clearInterval(id);
  // }, []);

  // remaining seconds for overlay
  // const remainingSeconds = activeWindow
  //   ? Math.max(
  //       0,
  //       Math.ceil((activeWindow.end.getTime() - now.getTime()) / 1000)
  //     )
  //   : 0;

  // below is for black screen for 10 minutes at prayer time🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  // below is for black screen for 10 minutes at prayer time🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻

  // below is for black screen for 10 minutes at prayer time🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  function timeToSeconds(str) {
    const [h, m] = str.split(":").map(Number);
    return h * 3600 + m * 60;
  }
  const [blackout, setBlackout] = useState(false);
  const [remaining, setRemaining] = useState(0);

  // durations in minutes
  const durations = {
    fajrIqamah: 20,
    dhuhrIqamah: 15,
    asrIqamah: 15,
    maghribIqamah: 20,
    ishaIqamah: 20,
  };

  useEffect(() => {
    if (!data) return;

    const now = new Date();
    const todaySeconds =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    Object.entries(durations).forEach(([key, minutes]) => {
      const targetSeconds = timeToSeconds(data[key]);
      const delay = (targetSeconds - todaySeconds) * 1000;

      if (delay > 0) {
        setTimeout(() => {
          const weekday = now.toLocaleDateString(undefined, {
            weekday: "long",
          });

          if (key === "dhuhrIqamah" && weekday === "Friday") {
            triggerBlackout(60);
          } else {
            triggerBlackout(minutes);
          }
        }, delay);
      }
    });
  }, [data]);

  function triggerBlackout(minutes) {
    setBlackout(true);
    setRemaining(minutes * 60);

    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setBlackout(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  // format remaining seconds as HH:MM:SS
  function formatTime2(sec) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(
      2,
      "0",
    )}:${String(s).padStart(2, "0")}`;
  }
  // above is for black screen for 10 minutes at prayer time🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  // //  // below Refresh the page a few seconds before the iqamah time.
  // //below Play azan exactly at the iqamah time.
  // function timeToSeconds1(str) {
  //   const [h, m] = str.split(":").map(Number);
  //   return h * 3600 + m * 60;
  // }
  // useEffect(() => {
  //   if (!data) return;

  //   const now = new Date();
  //   const todaySeconds =
  //     now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

  //   // mapping of iqamah times to refresh offsets
  //   const refreshOffsets = {
  //     fajrIqamah: 10,
  //     dhuhrIqamah: 11,
  //     asrIqamah: 12,
  //     maghribIqamah: 13,
  //     ishaIqamah: 14,
  //   };

  //   Object.entries(refreshOffsets).forEach(([key, offset]) => {
  //     const targetSeconds = timeToSeconds1(data[key]);
  //     const delayToIqamah = (targetSeconds - todaySeconds) * 1000;

  //     if (delayToIqamah > 0) {
  //       // Refresh before iqamah
  //       const refreshDelay = delayToIqamah - offset * 1000;
  //       if (refreshDelay > 0) {
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, refreshDelay);
  //       }

  //       // Azan exactly at iqamah
  //       // setTimeout(() => {
  //       //   playAzan();
  //       // }, delayToIqamah);
  //     }
  //   });
  // }, [data]);

  // function playAzan() {
  //   // Example: play audio file
  //   const audio = new Audio(IQAMAH); // put azan file in public folder
  //   audio.play();
  // }
  // //  // above Refresh the page a few seconds before the iqamah time.
  // //above Play azan exactly at the iqamah time.

  if (isLoading) {
    return (
      <div>
        <LoaderPage />
      </div>
    ); // Render a loading state first
  }

  if (error) {
    return <div>Error Loading</div>; // Render a loading state first
  }

  return (
    <>
      <div>
        <div
          className="left"
          style={{
            width: "60%",
            // height: "100vh",

            // filter: "drop-shadow(0 0 2px #6F47D3)",

            // background: "#316997ff",
            // background: "#3d7effff",
            background: "#ffffffff",

            color: "#0070bb",
            // border: "2px solid red",
            float: "left",
          }}
        >
          <div
            className="lontainer wrapper "
            style={{
              marginTop: "-35px",
              // marginBottom: "-10px",
            }}
          >
            <img
              src={MICLogo}
              className="icon-image"
              alt="Left Icon"
              // class=""
              style={{
                height: 70,
                width: 70,
                // marginTop: "-35px",
                // marginRight: "50px",
                //  gap: '100px'
              }}
            />

            <h3
              // className="word"
              // id="myText"
              style={{
                textAlign: "center",
                // marginTop: "1px",
                // marginBottom: "30px",
                fontSize: "40px",
                // fontFamily: "DM Sans, sans-serif",
                fontFamily: "Quicksand, sans-serif",

                fontStyle: "normal",
                // display: 'inline',
                letterSpacing: 3,
                // letterSpacing: "6px",
                color: "#0070bb",
                // textShadow: "2px 2px #1c7a1f",
              }}
            >
              MIDDLETOWN ISLAMIC CENTER
            </h3>
            <img
              src={MICLogo}
              className="icon-image"
              alt="Right Icon"
              style={{
                height: 70,
                width: 70,
                // marginTop: "-35px",
                // marginLeft: "50px",
                //  gap: '100px'
              }}
            />
          </div>
          <div
            className="Table-Title-div"
            style={{
              marginTop: "-26px",
            }}
          >
            <table
              style={{
                width: "100%",

                fontSize: "30px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",

                    // background: "#80CBC4",
                  }}
                >
                  <b> </b>
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",

                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  ATHAN
                </td>

                <td
                  style={{
                    width: "40%",
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                    fontWeight: "bold",
                  }}
                >
                  IQAMAH
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Fajr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                    verticalAlign: "bottom",

                    // background: "#80CBC4",
                  }}
                >
                  <b></b> FAJR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "88px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* 56:56 PM <br /> */}
                  {/* {formatTimeAMPM(bb.Fajr)}
                   */}
                  {data && format12h(data?.fajr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",
                    fontWeight: "bold",

                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Fajr_Iqamah)} */}
                  {data && format12h(data?.fajrIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Dhuhr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    textAlign: "right",
                    verticalAlign: "bottom",
                    fontSize: "40px",
                    // background: "#80CBC4",
                  }}
                >
                  <b></b>DHUHR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Dhuhr)} */}
                  {data && format12h(data?.dhuhr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Dhuhr_Iqamah)} */}
                  {data && format12h(data?.dhuhrIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Asr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>ASR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "88px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Asr)} */}
                  {data && format12h(data?.asr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "88px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Asr_Iqamah)} */}
                  {data && format12h(data?.asrIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Maghrib" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",
                    letterSpacing: -3,
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>MAGHRIB
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Maghrib)} */}
                  {data && format12h(data?.maghrib)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Maghrib_Iqamah)} */}
                  {data && format12h(data?.maghribIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Isha" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>ISHA
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Isha)} */}
                  {data && format12h(data?.isha)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* {formatTimeAMPM(bb.Isha_Iqamah)} */}
                  {data && format12h(data?.ishaIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div className="box">
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                // border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",
                    letterSpacing: -3,

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>JUMUAH
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* 1:00 PM */}
                  {data && format12h(data?.jumuah)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {data && format12h(data?.jumuahIqamah)}
                </td>
              </tr>
            </table>
          </div>
          <table
            style={{
              width: "100%",
              fontSize: "19px",
              // marginTop:'8px',
              border: "none !important",
              filter: "drop-shadow(0 0 2px #6F47D3)",
            }}
          >
            <tr
              style={{
                fontSize: "16px",
              }}
            >
              <td
                style={{
                  // border: "1px solid #dddddd",
                  textAlign: "center",
                  fontFamily: "Quicksand, sans-serif",
                  // fontWeight: "normal",
                  background: "#ffffffff",
                  // fontSize: "25px",
                  // marginTop: "-40px",
                }}
              >
                Tomorrow:&nbsp; <br />
                <b> {tomorroww && tomorroww}</b> &nbsp;
              </td>
              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Fajr)}
                  </td> */}

              {compareTime(
                data && format12h(data?.fajrIqamah),
                tData && format12h(tData?.fajrIqamah),
              ) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",
                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Fajr-Iqama &nbsp;&nbsp;
                    {tData && <b>{format12h(tData?.fajrIqamah)}</b>}
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    width: "120px",
                    // fontSize: "10px",
                    fontFamily: "Quicksand, sans-serif",
                    background: "#EA5B6F",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Fajr-Iqama &nbsp;&nbsp;
                    {/* {formatTimeAMPM(bb2.Fajr_Iqamah)} */}
                    {tData && format12h(tData?.fajrIqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      <b>{tData && format12h(tData?.fajrIqamah)}</b>
                    )}
                    <b
                      style={
                        {
                          // background: "#0118D8",
                        }
                      }
                    ></b>
                  </span>
                </td>
              )}

              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Dhuhr)}
                  </td> */}

              {compareTime(
                data && format12h(data?.dhuhrIqamah),
                tData && format12h(tData?.dhuhrIqamah),
              ) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",
                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Dhuhr-Iqama &nbsp;
                    <b>{tData && format12h(tData?.dhuhrIqamah)}</b>
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    width: "120px",

                    fontFamily: "Quicksand, sans-serif",
                    background: "#EA5B6F",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Dhuhr-Iqama &nbsp;
                    {/* {formatTimeAMPM(bb2.Dhuhr_Iqamah)} */}
                    {tData && format12h(tData?.dhuhrIqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      <b> {tData && format12h(tData?.dhuhrIqamah)}</b>
                    )}
                    <b
                      style={
                        {
                          // background: "#0118D8",
                        }
                      }
                    ></b>
                  </span>
                </td>
              )}

              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Asr)}
                  </td> */}

              {compareTime(
                data && format12h(data?.asrIqamah),
                tData && format12h(tData?.asrIqamah),
              ) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",
                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Asr-Iqama &nbsp;&nbsp;
                    <b> {tData && format12h(tData?.asrIqamah)}</b>
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    width: "120px",

                    fontFamily: "Quicksand, sans-serif",
                    background: "#EA5B6F",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Asr-Iqama &nbsp;&nbsp;&nbsp;
                    {/* {formatTimeAMPM(bb2.Dhuhr_Iqamah)} */}
                    {tData && format12h(tData?.asrIqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      <b>{tData && format12h(tData?.asrIqamah)}</b>
                    )}
                    <b
                      style={
                        {
                          // background: "#0118D8",
                        }
                      }
                    ></b>
                  </span>
                </td>
              )}

              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Maghrib)}
                  </td> */}

              {compareTime(
                data && format12h(data?.maghribIqamah),
                tData && format12h(tData?.maghribIqamah),
              ) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",
                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Maghrib-Iqama &nbsp;&nbsp;
                    <b>{tData && format12h(tData?.maghribIqamah)}</b>
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    width: "120px",

                    fontFamily: "Quicksand, sans-serif",
                    background: "#EA5B6F",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Maghrib-Iqama &nbsp;&nbsp;&nbsp;
                    {/* {formatTimeAMPM(bb2.Dhuhr_Iqamah)} */}
                    {tData &&
                    format12h(tData?.maghribIqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      <b> {tData && format12h(tData?.maghribIqamah)}</b>
                    )}
                    <b
                      style={
                        {
                          // background: "#0118D8",
                        }
                      }
                    ></b>
                  </span>
                </td>
              )}
              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Isha)}
                  </td> */}

              {compareTime(
                data && format12h(data?.ishaIqamah),
                tData && format12h(tData?.ishaIqamah),
              ) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",
                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Isha-Iqama &nbsp;
                    <b> {tData && format12h(tData?.ishaIqamah)}</b>
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    width: "120px",

                    fontFamily: "Quicksand, sans-serif",
                    background: "#EA5B6F",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Isha-Iqama &nbsp;&nbsp;&nbsp;
                    {/* {formatTimeAMPM(bb2.Dhuhr_Iqamah)} */}
                    {tData && format12h(tData?.ishaIqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      <b> {tData && format12h(tData?.ishaIqamah)}</b>
                    )}
                    <b
                      style={
                        {
                          // background: "#0118D8",
                        }
                      }
                    ></b>
                  </span>
                </td>
              )}
            </tr>
          </table>
        </div>
        <div
          className="right"
          style={{
            width: "40%",
            height: "98.5vh",
            // filter: "drop-shadow(0 0 2px #6F47D3)",

            // background: "#316997ff",
            // background: "#FFD93D",
            background: "#0070bb",
            color: "black",
            // border: "2px solid red",
            float: "left",
          }}
        >
          <div
            // className="1"
            style={{
              height: "35%",
              width: "100%",
              // background: "pink",
              // marginTop: "-5px",
              marginRight: "20px",
              borderBottom: "1px solid #dddddd",
            }}
          >
            <h2
              style={{
                marginTop: "-5px",
                textAlign: "center",
                fontSize: "45px",
                color: "white",
              }}
            >
              NOW
            </h2>
            <p
              style={{
                marginTop: "-50px",
                fontSize: "93px",
                textAlign: "center",
                fontFamily: "Space Mono, monospace",
                letterSpacing: -4,
                color: "white",
              }}
              className="ClockFont"
            >
              {/* <b>56:56:56 PM</b> <br /> */}
              <b>{formatTime(currentTime)}</b>
            </p>
            <p
              style={{
                marginTop: "-98px",
                fontSize: "40px",
                fontFamily: "Quicksand, sans-serif",
                color: "white",
                textAlign: "center",
              }}
            >
              {/* {dayName}, {todaysDateIs} */}
              {today && today}
              <br />
            </p>
            <p
              style={{
                marginTop: "-30px",
                color: "white",
                fontFamily: "Quicksand, sans-serif",
                fontSize: "35px",
                textAlign: "center",
              }}
            >
              {/* <b>{hijriDate}</b> */}
              {writeIslamicDate()}

              <br />
            </p>
          </div>
          <div
            className="2"
            style={{
              height: "37%",
              borderBottom: "1px solid #dddddd",

              // background: "red",
            }}
          >
            <p
              style={{
                marginTop: "5px",
                textAlign: "center",
                fontFamily: "Quicksand, sans-serif",
                fontSize: "28px",
                color: "white",
              }}
            >
              {/* &nbsp; Next Iqama is&nbsp;<span>{nextPrayer.label}</span> */}
              {/* &nbsp; The Call To Prayer Of&nbsp;<span>{activeWindow.prayerName}</span> */}
              Next Iqama is for {removeIqamah(nextPrayer1)} Prayer In
              {/* @&nbsp; */}
              <span
                style={{
                  fontSize: "30px",
                }}
              >
                {/* <b>{formatTimeAMPM(nextPrayer.time || 0)}</b> */}
              </span>
            </p>

            <p
              style={{
                marginTop: "-40px",
                fontSize: "105px",
                textAlign: "center",
                color: "white",

                fontFamily: "Space Mono, monospace",
                letterSpacing: -8,
              }}
              className="ClockFont"
            >
              -<b>{isPlayingAzan ? "🔊 Playing Azan..." : countdown1}</b>
              <br />
            </p>
            <p
              style={{
                marginTop: "-135px",
                filter: "drop-shadow(0 0 2px #6F47D3)",
                // marginLeft: "20px",
                // marginLeft: "-260px",
                textAlign: "center",
                fontSize: "20px",
                color: "#0070bb",

                // marginTop: "-66px",
                // fontSize: "89px",
                // textAlign: "center",
                // fontFamily: "Space Mono, monospace",
                // letterSpacing: -5,
              }}
            >
              <span
                style={{
                  // marginTop: "-135px",
                  marginLeft: "70px",
                  borderRadius: "6px",

                  textAlign: "center",
                  fontSize: "20px",
                  background: "white",
                  // filter: "drop-shadow(0 0 2px #6F47D3)",

                  // marginTop: "-66px",
                  // fontSize: "89px",
                  // textAlign: "center",
                  // fontFamily: "Space Mono, monospace",
                  // letterSpacing: -5,
                }}
              >
                &nbsp; SECONDS &nbsp;
              </span>
              <span
                style={{
                  // marginTop: "-135px",
                  marginLeft: "-270px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "20px",
                  background: "white",
                  // filter: "drop-shadow(0 0 2px #6F47D3)",

                  // marginTop: "-66px",
                  // fontSize: "89px",
                  // textAlign: "center",
                  // fontFamily: "Space Mono, monospace",
                  // letterSpacing: -5,
                }}
              >
                &nbsp; MINUTES &nbsp;
              </span>
              <span
                style={{
                  // marginTop: "-135px",
                  marginLeft: "-260px",
                  borderRadius: "6px",

                  textAlign: "center",
                  fontSize: "20px",
                  background: "white",
                  // filter: "drop-shadow(0 0 2px #6F47D3)",

                  // marginTop: "-66px",
                  // fontSize: "89px",
                  // textAlign: "center",
                  // fontFamily: "Space Mono, monospace",
                  // letterSpacing: -5,
                }}
              >
                &nbsp;&nbsp; HOURS &nbsp;&nbsp;
              </span>
            </p>
            <div
              className="main-container-flex"
              style={{
                height: "40%",
                // borderBottom: "1px solid #dddddd",
                // background: "red",
                marginTop: "-8px",
              }}
            >
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",

                  // background: "pink",
                }}
              >
                SUN-RISE:&nbsp; <b>{data && format12h(data?.sunrise)}</b>
              </div>
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "28px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",
                  letterSpacing: -1,

                  // background: "pink",
                }}
              >
                SAHUR-END'S: &nbsp;<b> {data && format12h(data?.fajr)}</b>
              </div>
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",
                  textAlign: "center",
                  // background: "blue",
                }}
              >
                SUN-SET: &nbsp;<b>{data && format12h(data?.maghrib)}</b>
              </div>
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",

                  // background: "pink",
                }}
              >
                IFTAR:&nbsp; <b>{data && format12h(data?.maghrib)}</b>
              </div>
            </div>
          </div>
          <div
            className="3"
            style={{
              height: "26%",
              // background: "black",
            }}
          >
            <div
              style={{
                height: "80%",
                // borderBottom: "1px solid #dddddd",

                // background: "red",
              }}
            >
              <div
                className="box"
                style={{
                  marginTop: "8px",
                  marginLeft: "8px",

                  width: 190,
                  height: 185,
                  float: "left",
                  textAlign: "center",
                  backgroundSize: "cover", // Optional: Adjust how the image is sized
                  backgroundImage: `url(${paypal})`,
                  // height: "100vh",
                  backgroundPosition: "center",
                  // textShadow: "5px 2px #558abb",
                  backgroundRepeat: "no-repeat",
                  // backgroundColor: "rgba(0, 0, 0, 0.5)",

                  // backgroundColor: "#3F4F44",

                  // color: "white",
                  // marginLeft: "-5px",
                }}
              ></div>

              <div
                className="box"
                style={{
                  marginTop: "8px",
                  marginRight: "8px",
                  width: 185,
                  height: 185,
                  float: "right",
                  textAlign: "center",
                  backgroundSize: "cover", // Optional: Adjust how the image is sized
                  backgroundImage: `url(${zelle})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  // height: "100vh",
                  // textShadow: "5px 2px #558abb",
                  // backgroundColor: "rgba(0, 0, 0, 0.5)",

                  // backgroundColor: "#3F4F44",

                  // color: "white",
                  // marginLeft: "-5px",
                }}
              ></div>
            </div>
            <br />
            <div
              style={{
                height: "20%",
                // borderBottom: "1px solid #dddddd",

                // background: "red",
              }}
            >
              <p
                style={{
                  // width: "100%",
                  // fontSize: "15px",
                  marginTop: "2px",
                  fontFamily: "Quicksand, sans-serif",
                  marginLeft: "8px",
                  // fontWeight: "bold",
                  // textAlign: "center",
                  color: "white",
                }}
              >
                <b>
                  Application Developer:{" "}
                  <span
                    style={{
                      fontSize: "15px",
                    }}
                  >
                    MEHDI HASAN
                  </span>{" "}
                  || 845.514.8834 || Message To Suggest.
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

//⬆️⬆️🆙🆙⬆️⬆️🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝 up all for countdown for azan code 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝⬆️⬆️🆙🆙⬆️⬆️

export default FrontDeskNewDataData;
